/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from 'assets/theme-dark/base/colors';

// Material Dashboard 2 React helper functions
import pxToRem from 'assets/theme-dark/functions/pxToRem';

const { transparent } = colors;

const select = {
  styleOverrides: {
    select: {
      display: 'grid',
      alignItems: 'center',
      // Zero vertical padding collapsed every Select app-wide down to just
      // its text line-height (visibly shorter than a same-size TextField
      // next to it, in size="small" or default) — restore the same 10px
      // vertical padding TextField's inputSizeSmall already uses, plus an
      // explicit 36px floor so it never renders shorter than that
      // regardless of font-size.
      padding: `${pxToRem(10)} ${pxToRem(12)} !important`,
      minHeight: '36px !important',
      boxSizing: 'border-box',

      '& .Mui-selected': {
        backgroundColor: transparent.main,
      },
    },

    selectMenu: {
      background: 'none',
      overflow: 'unset',
    },

    icon: {
      display: 'none',
    },
  },
};

export default select;
